<div class="modal-header">
    <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" (click)="cancel()"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title" id="labelButtons">Add Phone Number(s)</h4>
</div>

<div class="modal-body" *ngIf="data" [formGroup]="watchYourCarForm">
    <validation-results [validationResults]="validationModel" *ngIf="validationModel.validationResults.length > 0"></validation-results>
    <fieldset>
        <div class="row">
            <div class="col-md-3 mvd_form-group">
                <label class="required" title="* Required">Phone Number 1</label>
                <p-inputMask styleClass="mvd_form-control" mask="999-999-9999" placeholder="xxx-xxx-xxxx" formControlName="phone1"></p-inputMask>
                <control-validation-messages control="phone1"></control-validation-messages>
            </div>
            <div class="col-md-3 mvd_form-group">
                <label>Phone Number 2</label>
                <p-inputMask styleClass="mvd_form-control" mask="999-999-9999" placeholder="xxx-xxx-xxxx" formControlName="phone2"></p-inputMask>
            </div>
        </div>
    </fieldset>
</div>

<div class="modal-footer">
    <div class="btn--group">
        <button class="btn--default" type="button" (click)="cancel()">Cancel</button>
        <button class="btn--primary" type="submit" (click)="save()">Save</button>
    </div>
</div>